import navBarHomepage from '../modules/navbar-homepage';
import forgotPassword from '../modules/forgot_password';
let forgotPasswordController = () => {
    navBarHomepage.on();
    forgotPassword.on();
};

export default forgotPasswordController;
